import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// UPDATE SUB-CHANNEL FACILITATORS
export const updateSubChannelFacilitators = createAsyncThunk(
	"updateSubChannelFacilitators",
	async ({ channel_id, id, facilitators, new_facilitators, existing_facilitators }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`/channel/${channel_id}/sub_channel/${id}/facilitators`, {
				facilitators,
				new_facilitators,
				existing_facilitators,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const UpdateSubChannelFacilitatorsSlice = createSlice({
	name: "UpdateSubChannelFacilitatorsSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetUpdateSubChannelFacilitatorsState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateSubChannelFacilitators.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateSubChannelFacilitators.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateSubChannelFacilitators.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateSubChannelFacilitatorsState } = UpdateSubChannelFacilitatorsSlice.actions;
export default UpdateSubChannelFacilitatorsSlice.reducer;
